import { AuthenticationEffects } from '@/store/authentication/authentication.effects';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    public autheffect: AuthenticationEffects,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private router: Router
  ) {}
  intercept(
    request: HttpRequest<Request>,
    next: HttpHandler
  ): Observable<HttpEvent<Event>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let error = err;
        if (err instanceof HttpErrorResponse) {
          error = err.error.message || err.statusText;

          if (err.status >= 500) {
            this.toastr.error('Server Error: Something went wrong');
          }
          if (err.status >= 400 && err.status < 500) {
            let message = error;
            if (err.error.errors) {
              if (Array.isArray(err.error.errors) && err.error.errors.length) {
                message = err.error.errors[0].message;
                if (typeof err.error.errors[0] == 'string') {
                  message = err.error.errors[0];
                }
              } else {
                Object.keys(err.error.errors).forEach((key) => {
                  if (
                    Array.isArray(err.error.errors[key]) &&
                    err.error.errors[key].length
                  ) {
                    message = err.error.errors[key][0];
                  }
                });
              }
            }
            this.toastr.error(typeof message === 'string' ? message : error);
          }

          if (err.status === 401) {
            this.authenticationService.removeSession();
            this.router.navigate(['auth/login'], {
              replaceUrl: true,
            });
          }
        }
        return throwError(error);
      })
    );
  }
}
